import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NewUiLoginComponent } from "./new-ui-login.component";

@Component({
  selector: "app-login",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent extends NewUiLoginComponent {}
